var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/notification-status"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification-status"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.25 6.5625C12.6975 6.5625 11.4375 5.3025 11.4375 3.75C11.4375 2.1975 12.6975 0.9375 14.25 0.9375C15.8025 0.9375 17.0625 2.1975 17.0625 3.75C17.0625 5.3025 15.8025 6.5625 14.25 6.5625ZM14.25 2.0625C13.32 2.0625 12.5625 2.82 12.5625 3.75C12.5625 4.68 13.32 5.4375 14.25 5.4375C15.18 5.4375 15.9375 4.68 15.9375 3.75C15.9375 2.82 15.18 2.0625 14.25 2.0625Z",
    fill: "#0A5EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 10.3125H5.25C4.9425 10.3125 4.6875 10.0575 4.6875 9.75C4.6875 9.4425 4.9425 9.1875 5.25 9.1875H9C9.3075 9.1875 9.5625 9.4425 9.5625 9.75C9.5625 10.0575 9.3075 10.3125 9 10.3125Z",
    fill: "#0A5EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 13.3125H5.25C4.9425 13.3125 4.6875 13.0575 4.6875 12.75C4.6875 12.4425 4.9425 12.1875 5.25 12.1875H12C12.3075 12.1875 12.5625 12.4425 12.5625 12.75C12.5625 13.0575 12.3075 13.3125 12 13.3125Z",
    fill: "#0A5EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.25 17.0625H6.75C2.6775 17.0625 0.9375 15.3225 0.9375 11.25V6.75C0.9375 2.6775 2.6775 0.9375 6.75 0.9375H10.5C10.8075 0.9375 11.0625 1.1925 11.0625 1.5C11.0625 1.8075 10.8075 2.0625 10.5 2.0625H6.75C3.2925 2.0625 2.0625 3.2925 2.0625 6.75V11.25C2.0625 14.7075 3.2925 15.9375 6.75 15.9375H11.25C14.7075 15.9375 15.9375 14.7075 15.9375 11.25V7.5C15.9375 7.1925 16.1925 6.9375 16.5 6.9375C16.8075 6.9375 17.0625 7.1925 17.0625 7.5V11.25C17.0625 15.3225 15.3225 17.0625 11.25 17.0625Z",
    fill: "#0A5EF3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/reminder.4eab04f31591390dc827b1195d4eb645.svg";
export { ForwardRef as ReactComponent };